import { useState, useContext, useEffect } from 'react';
import './ChatMobile.css'; // Novo CSS mobile
import Historico from '../../Historico';
import UnifiedChat from '../../UnifiedChat/UnifiedChat';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { useTranslation } from 'react-i18next';
import { AuthContext } from '../../../authContext';
import { getDefaultChatModel } from '../../../utils/assistantModels';

function ChatMobile({ chatHistory, setChatHistory, loading, setLoading, sessions, setSessions, selectedSession, setSelectedSession, summaryInfo, setSummaryInfo, totalCost, setTotalCost, sessionId, setSessionId, user, assistant, assistantId, messageSent, setMessageSent }) {

    const [view, setView] = useState('chat'); // valores: 'chat' ou 'historico-overlay'
    const { t: tChat } = useTranslation('chat');
    const [, setLinks] = useState([]);
    const defaultChatModel = getDefaultChatModel(assistantId);
    const [selectedModel, setSelectedModel] = useState(defaultChatModel);

    const openHistoricoOverlay = () => setView('historico-overlay');
    const closeHistoricoOverlay = () => setView('chat');

    const { newSessionId } = useContext(AuthContext);

    // Função para criar Novo Chat diretamente no frontend
    const createNewChat = () => {
        try {
            // Chama a função para gerar o novo session_id e armazena o retorno
            const generatedSessionId = newSessionId();
            const newSession = { label: "New Chat", session_id: generatedSessionId };
            setSummaryInfo({ label: "New Chat", status: false, session_id: generatedSessionId });

            // Define o histórico inicial no formato esperado
            const history = [
                { role: "system", content: "" },
                { role: "assistant", content: tChat('newSessionGreeting') }
            ];
            // Atualiza as sessões e o histórico
            setSessions([newSession, ...sessions]); // Adiciona o novo session_id à lista
            setSelectedSession(generatedSessionId); // Define a nova sessão como selecionada
            setChatHistory(history); // Atualiza o histórico do chat no componente pai
            setLinks([]);
            setSelectedModel(defaultChatModel);
            setMessageSent(false);

        } catch (error) {
            console.error('Erro ao criar nova sessão:', error);
        }
    };

    useEffect(() => {
        setSelectedModel(defaultChatModel);
    }, [defaultChatModel]);

    const renderView = () => {
        switch (view) {
            case 'chat':
                return (
                    <ErrorBoundary resetKeys={[sessionId]} errorContext={{ sessionId, assistantId, email: user }}>
                        <UnifiedChat
                            chatHistory={chatHistory}
                            setChatHistory={setChatHistory}
                            classeCSS="chatbox-mobile"
                            loading={loading}
                            sessionId={sessionId}
                            totalCost={totalCost}
                            setTotalCost={setTotalCost}
                            user={user}
                            setLinks={setLinks}
                            assistant={assistant}
                            assistantId={assistantId}
                            isMobile={true}
                            // Celular é sempre <1024px - mesma regra do tablet (Tarefa 10 de
                            // specs/front_planning_tools/plan.md): pill/indicador aparecem sem
                            // seta/clique, sem painel (que nem existe nesta tela).
                            hideActivityPanel={true}
                            createNewChat={createNewChat}
                            openHistoricoOverlay={openHistoricoOverlay}
                            summaryInfo={summaryInfo}
                            updateSummary={(updated) =>
                                setSummaryInfo(prev => ({ ...prev, ...updated }))
                            }
                            setSessions={setSessions}
                            selectedModel={selectedModel}
                            setSelectedModel={setSelectedModel}
                            messageSent={messageSent}
                            setMessageSent={setMessageSent}
                        />
                    </ErrorBoundary>
                );
            case 'historico-overlay':
                return (
                    <div className="historico-overlay">
                        <ErrorBoundary resetKeys={[sessionId]} errorContext={{ sessionId, assistantId, email: user }}>
                            <Historico
                                setChatHistory={setChatHistory}
                                classeCSS="historico-mobile"
                                newButtonName={tChat("new_chat")}
                                isReportMode={false}
                                setLoading={setLoading}
                                sessions={sessions}
                                setSessions={setSessions}
                                selectedSession={selectedSession}
                                setSelectedSession={setSelectedSession}
                                sessionId={sessionId}
                                setSessionId={setSessionId}
                                user={user}
                                assistantId={assistantId}
                                isMobile={true}
                                createNewChat={createNewChat}
                                closeHistoricoOverlay={closeHistoricoOverlay}
                                summaryInfo={summaryInfo}
                                setSummaryInfo={setSummaryInfo}
                                messages={chatHistory}
                            />
                        </ErrorBoundary>
                    </div>

                );
            default:
                return null;
        }
    };


    return (
        <div className="chat-mobile-container">
            {renderView()}
        </div>
    );
}

export default ChatMobile;
